<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>

            </div>

            <el-table
                :data="residentList"
                alig="center"
                border
                header-row-class-name="table-header"
                row-class-name="table-row"
                style="width: 100%">
                <el-table-column align="center" label="序号" type="index" width="70"></el-table-column>
                <el-table-column label="姓名" prop="user_name"  width="150"></el-table-column>
                <el-table-column label="手机号" prop="user_phone"  width="150"></el-table-column>
                <el-table-column label="积分" prop="points"  width="150"></el-table-column>
                <el-table-column label="创建时间" prop="create_time"  width="180"></el-table-column>
                <el-table-column label="描述" prop="message"></el-table-column>
            </el-table>
            <el-pagination
                v-if="residentList.length > 0"
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all"
                layout="prev, pager, next, jumper"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getPointsLogs} from "@/api/gzh";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            id: '',
            state: '', //状态 0兑换中 1已兑换 2项目经理取消 3兑换人取消
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/home/gzh/member', "双暖为老 / 商品管理 / 人员管理", true);
        this.id = this.$route.params.id
        this.getList()
    },
    methods: {

        //  获取商品列表
        async getList() {
            let _data = await getPointsLogs(
                this.keyword,
                this.id,
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        hanldSearch() {
            this.page = 1
            this.getList()
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>

</style>
